import { PersonalAPI } from "@/api/PersonalAPI";

export const indexModule = {
    state: () => ({
        personalData: {}
    }),
    getters: {
        personalData: state => state.personalData,
        contractObject: state => state.personalData.ContractObject || null,
    },
    mutations: {
        setPersonalData(state, userData) {
            state.personalData = userData
        },
    },
    actions: {
      async getPersonalData({ commit, rootState }){
        return await PersonalAPI.getPersonalData(rootState.authorization.userId)
          .then(res => {
            commit("setPersonalData", res.data)
            return res.status;
          })
          .catch((error) => {
            let errorStatus = error.response.status

            if (String(errorStatus).startsWith('4')){
              commit('clientError', null, { root: true })
            }else if(String(errorStatus).startsWith('5')){
              commit('serverError', null, { root: true })
            }
            
            return errorStatus;
          });
      }
    },
    namespaced: true
}